module.exports = __webpack_public_path__ + "img/azure-fundamentals.04f59e6f.png";